import styled from 'styled-components';

export const ArmyOrgSection = styled.div`
  background-color: white;
  border: 2px solid black;
  margin: 1% 5%;
  max-width: 1024px;
  min-height: 70px;
  position: relative;
`;
